/** Canonical production origin (HTTPS, preferred host). */
export const SITE_URL = 'https://wesamtechnologies.com';

/** Absolute URL for Open Graph / share image. */
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

/** Routes that should return HTTP 200 and be listed in the sitemap. */
export const SPA_ROUTES = [
  '/',
  '/aboutMe',
  '/services',
  '/portfolio',
  '/manifesto',
  '/contact',
  '/privacy',
];

export const SAME_AS = [
  'https://www.linkedin.com/in/wesam-abdel',
  'https://github.com/wewesemsem',
  'https://www.youtube.com/@WesamTechnologies',
];

/** Organization JSON-LD for the home page (Google Organization docs). */
export const ORGANIZATION_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Wesam Technologies',
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  description:
    'Wesam Technologies provides full stack software engineering, cloud, and AI solutions.',
  email: 'hello@wesamtechnologies.com',
  sameAs: SAME_AS,
  founder: {
    '@type': 'Person',
    name: 'Wesam Abdelzaher',
    url: `${SITE_URL}/aboutMe`,
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@wesamtechnologies.com',
    url: `${SITE_URL}/contact`,
  },
};

/** ProfilePage JSON-LD for the About page (Google ProfilePage docs). */
export const PROFILE_PAGE_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'ProfilePage',
  mainEntity: {
    '@type': 'Person',
    name: 'Wesam Abdelzaher',
    description:
      'Full stack software engineer and founder of Wesam Technologies.',
    image: `${SITE_URL}/wesam-portrait.jpg`,
    url: `${SITE_URL}/aboutMe`,
    sameAs: SAME_AS,
    worksFor: {
      '@type': 'Organization',
      name: 'Wesam Technologies',
      url: SITE_URL,
    },
  },
};

export const PAGE_META = {
  '/': {
    title: 'Wesam Technologies | Full Stack Software Engineer',
    description:
      'Wesam Abdelzaher — full stack software engineer. Explore services, portfolio projects, and get in touch with Wesam Technologies.',
    jsonLd: ORGANIZATION_JSON_LD,
  },
  '/aboutMe': {
    title: 'About Wesam Abdelzaher | Wesam Technologies',
    description:
      'About Wesam Abdelzaher: education, certifications, and experience as a full stack software engineer at Wesam Technologies.',
    jsonLd: PROFILE_PAGE_JSON_LD,
  },
  '/services': {
    title: 'Software Engineering Services | Wesam Technologies',
    description:
      'Software engineering services from Wesam Technologies — full stack development, cloud, and custom solutions.',
  },
  '/portfolio': {
    title: 'Portfolio | Wesam Technologies',
    description:
      'Selected software projects and apps by Wesam Abdelzaher, including mobile and web work, plus a living manifesto.',
  },
  '/manifesto': {
    title: 'Manifesto | Wesam Technologies',
    description:
      'A living, iterative manifesto by Wesam Abdelzaher — writing added as the work and the thinking move.',
  },
  '/contact': {
    title: 'Contact | Wesam Technologies',
    description:
      'Contact Wesam Technologies at hello@wesamtechnologies.com to discuss a project or collaboration.',
  },
  '/privacy': {
    title: 'Privacy Policy | Wesam Technologies',
    description:
      'Privacy policy for wesamtechnologies.com and how Wesam Technologies handles personal information.',
  },
};

export const NOT_FOUND_META = {
  title: 'Page Not Found | Wesam Technologies',
  description: 'The page you requested could not be found on Wesam Technologies.',
  noindex: true,
};
